var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Reserve-transfer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: 17.4699981,
    cy: 17.4198516,
    rx: 17.4699981,
    ry: 17.4198516
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.5%",
    y: "-20.1%",
    width: "163.0%",
    height: "163.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.192156863   0 0 0 0 0.239215686  0 0 0 0.08 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.192156863   0 0 0 0 0.239215686  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recent_Transactions",
    transform: "translate(-4.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transactions"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Reserve-transfer",
    transform: "translate(10.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.1223038,8.80035611 C17.3358724,8.67037329 17.6044918,8.67037329 17.8180604,8.80035611 L25.2565681,13.3247898 C25.4065689,13.4160117 25.4980759,13.5784595 25.4980759,13.7535396 L25.4980759,14.3696384 C25.4980759,14.4582995 25.462703,14.5433254 25.3997644,14.6060089 C25.3368259,14.6686924 25.251469,14.7038983 25.1624737,14.7038806 L24.1600825,14.7038806 C23.9753441,14.7038806 23.8255841,14.8530784 23.8255841,15.0371231 L23.8255841,21.0962052 C23.825614,21.2123278 23.8863181,21.3200612 23.9858088,21.3805611 L25.2565681,22.1533838 C25.4065684,22.2445901 25.4980759,22.4070287 25.4980759,22.5821003 L25.4980759,23.6979629 C25.4980759,23.7866536 25.4626935,23.8717083 25.3997371,23.9344159 C25.3367806,23.9971235 25.2513984,24.0323384 25.1623734,24.0323384 L9.77648558,24.0323384 C9.59174724,24.0323384 9.44192032,23.8831406 9.44192032,23.6990959 L9.44192032,22.5814005 C9.44192032,22.4067924 9.53324242,22.2447806 9.68282604,22.1537837 L10.9542878,21.3804278 C11.0537489,21.3199439 11.1144195,21.2122277 11.1144121,21.0961386 L11.1144121,15.0370898 C11.1144121,14.853045 10.9646521,14.7038473 10.7799138,14.7038473 L9.77641868,14.7038473 C9.59168034,14.7038473 9.44192032,14.5546495 9.44192032,14.3706048 L9.44192032,13.7527065 C9.44192032,13.5781254 9.53318168,13.4161446 9.68275914,13.3251897 L17.1223038,8.80035611 Z M20.146169,21.0312229 C20.146169,21.2152677 20.295929,21.3644655 20.4806674,21.3644655 L21.8186608,21.3644655 C22.0033992,21.3644655 22.1531592,21.2152677 22.1531592,21.0312229 L22.1531592,15.0370898 C22.1531592,14.853045 22.0033992,14.7038473 21.8186608,14.7038473 L20.4806674,14.7038473 C20.295929,14.7038473 20.146169,14.853045 20.146169,15.0370898 L20.146169,21.0312229 Z M16.466687,21.0312229 C16.466687,21.2152677 16.616447,21.3644655 16.8011854,21.3644655 L18.1391788,21.3644655 C18.3239172,21.3644655 18.4736772,21.2152677 18.4736772,21.0312229 L18.4736772,15.0370898 C18.4736772,14.853045 18.3239172,14.7038473 18.1391788,14.7038473 L16.8011854,14.7038473 C16.616447,14.7038473 16.466687,14.853045 16.466687,15.0370898 L16.466687,21.0312229 Z M17.4701821,13.0354686 C18.0242373,13.0353398 18.4732951,12.5877939 18.4732089,12.0358189 C18.4731227,11.4838438 18.0239252,11.0364371 17.4698699,11.0364801 C16.9158147,11.036523 16.466687,11.4839993 16.466687,12.0359743 C16.4667794,12.5879906 16.9160187,13.0354239 17.4701152,13.0353686 L17.4701821,13.0354686 Z M12.787205,21.0312229 C12.787205,21.2152677 12.936965,21.3644655 13.1217034,21.3644655 L14.4596968,21.3644655 C14.6444352,21.3644655 14.7941952,21.2152677 14.7941952,21.0312229 L14.7941952,15.0370898 C14.7941952,14.853045 14.6444352,14.7038473 14.4596968,14.7038473 L13.1217034,14.7038473 C12.936965,14.7038473 12.787205,14.853045 12.787205,15.0370898 L12.787205,21.0312229 Z",
    id: "Bank",
    fill: "#7CE3EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fill: "#1AB7C8",
    cx: 23.7591975,
    cy: 23.6909982,
    rx: 4.19279955,
    ry: 4.18076439
  }), /*#__PURE__*/React.createElement("g", {
    id: "Transfer-Icon-Copy",
    transform: "translate(20.963998, 21.252219)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.67410743,2.35322758 L0.569532175,2.35322758 C0.439118796,2.35322758 0.272542207,2.19976036 0.272542207,2.06287716 C0.272542207,1.92599397 0.439118796,1.76949019 0.569532175,1.76949019 L4.67010495,1.76949019 L3.30204901,0.423339334 C3.20981414,0.326412343 3.20990401,0.169356961 3.30224972,0.072546321 C3.39459543,-0.0242643194 3.54422756,-0.0241699985 3.63646242,0.0727569926 L5.41011446,1.93218179 C5.45446892,1.97864001 5.47939475,2.04170892 5.47939475,2.10747915 C5.47939475,2.17324939 5.45446892,2.30676936 5.41011446,2.35322758 L4.67410743,2.35322758 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67410743,5.14040384 L0.569532175,5.14040384 C0.439118796,5.14040384 0.272542207,4.98693662 0.272542207,4.85005342 C0.272542207,4.71317023 0.439118796,4.55666645 0.569532175,4.55666645 L4.67010495,4.55666645 L3.30204901,3.21051559 C3.20981414,3.1135886 3.20990401,2.95653322 3.30224972,2.85972258 C3.39459543,2.76291194 3.54422756,2.76300626 3.63646242,2.85993325 L5.41011446,4.71935804 C5.45446892,4.76581626 5.47939475,4.82888518 5.47939475,4.89465541 C5.47939475,4.96042564 5.45446892,5.09394562 5.41011446,5.14040384 L4.67410743,5.14040384 Z",
    id: "Shape",
    transform: "translate(2.875968, 3.963790) scale(-1, -1) translate(-2.875968, -3.963790) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.9041127b51a148c65e38572e31fa41f8.svg";
export { ForwardRef as ReactComponent };